module.exports = __webpack_public_path__ + "static/media/Thumbnail-Ultradent-Dr-Kusek.ec71cd05.png";